<div
  class="header-section-grid__container"
  [ngClass]="{
    'u-row': config?.direction === HeaderContentDirections.column,
    'u-column': config?.direction === HeaderContentDirections.row,
  }"
>
  @for (
    headerContentConfig of config?.headerContent;
    track headerContentConfig
  ) {
    <header-content [config]="headerContentConfig">
      @if (contentMap[headerContentConfig.prop]) {
        <ng-container
          *ngTemplateOutlet="contentMap[headerContentConfig.prop]"
        ></ng-container>
      }
    </header-content>
  }
</div>
